export default __webpack_public_path__ + "static/plexus-mobile-1-mobile-138c1fa0066628362524ae7db993aef1.webp";